.eyebrow {
  display: block;
  margin-bottom: 1.4rem;
}
